class CartNotification extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    this.addToCartForms.forEach(form => {
      form.addEventListener('submit', this.handleCartUpdate);
    })
  }

  disconnectedCallback() {
    this.addToCartForms.forEach(form => {
      form.removeEventListener('submit', this.handleCartUpdate);
    })
  }

  async handleCartUpdate(e) {

    e.preventDefault();

    this.dataset.visibility = 'show';

    setTimeout(() => {
      this.dataset.visibility = 'hidden';
    }, 4000)

    // submit form with ajax
    const form = e.target;
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    })

  }
}

customElements.define('cart-notification', CartNotification);
